import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=4684ed00&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=4684ed00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684ed00",
  null
  
)

export default component.exports